import { getCapabilityBehaviorByValueType } from './capabilityDynamicFieldsConfig';
import { isExistingUserCodeKey } from './isExistingUserCodeKey';
import { isPinRequiredForAction } from './isPinRequiredForAction';

/**
 * Resolves the "user" (PIN key) field value at restore time so downstream RENDERING reads it O(1) from
 * capabilityDynamicFields. Only actions that require a PIN (per the config, requiresPin) reference user_codes: the
 * key is kept when present in the dictionary and normalized to null when missing (an orphan value, e.g. digits typed
 * manually in the mobile app, which then surfaces as an error in SelectPinCode). Actions that need no PIN are
 * returned unchanged (e.g. keypad "incorrect" with user = -1).
 * @param {string} valueType - capability value type
 * @param {string} stateFieldValue - restored "state" field value (action token)
 * @param {string} userFieldValue - restored "user" field value (PIN key)
 * @param {string} userCodesItemId - id of the user_codes item referenced by the block
 * @param {Array} items - controller items
 * @param {string} deviceId - device id
 * @returns {string|null}
 */
export const getRestoredUserFieldValue = (
    valueType,
    stateFieldValue,
    userFieldValue,
    userCodesItemId,
    items,
    deviceId,
) => {
    const actionOptions = getCapabilityBehaviorByValueType(valueType)?.actionOptions;

    if (!isPinRequiredForAction(actionOptions, stateFieldValue)) {
        return userFieldValue;
    }

    return isExistingUserCodeKey(userFieldValue, userCodesItemId, items, deviceId) ? userFieldValue : null;
};
